import React from "react";
import { useSearchParams } from "react-router-dom";

export const CanvaCallback: React.FC = () => {
  const [searchParams] = useSearchParams();

  React.useEffect(() => {
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    const error = searchParams.get("error");

    if (window.opener) {
      window.opener.postMessage(
        { type: "canva-callback", code, state, error },
        window.location.origin
      );
    }
  }, [searchParams]);

  return (
    <div className="text-center p-5">
      <h4>Connecting to Canva...</h4>
      <p>This window should close automatically.</p>
    </div>
  );
};
